import { Box, Skeleton } from "@mui/material";

const StrategyCardSkeleton = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "background.paper",
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        overflow: "hidden",
        height: "100%",
      }}
    >
      {/* Chart placeholder */}
      <Skeleton variant="rectangular" height={185} animation="wave" sx={{ bgcolor: "action.hover" }} />

      {/* Content */}
      <Box sx={{ p: 2, display: "flex", flexDirection: "column", gap: 1 }}>
        <Skeleton variant="text" width="60%" height={24} animation="wave" />
        <Skeleton variant="text" width="40%" height={16} animation="wave" />
        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 0.5 }}>
          <Skeleton variant="text" width="35%" height={32} animation="wave" />
          <Skeleton variant="text" width="25%" height={32} animation="wave" />
        </Box>
        <Box sx={{ display: "flex", gap: 0.75 }}>
          <Skeleton variant="rounded" width={60} height={20} animation="wave" />
          <Skeleton variant="rounded" width={70} height={20} animation="wave" />
        </Box>
      </Box>
    </Box>
  );
};

export default StrategyCardSkeleton;
